<template>
    <el-tooltip :content="value" :disabled="tooltipDisabled" placement="top-start">
        <span ref="content" @mouseover="isShowTooltip">{{subValue}}</span>
    </el-tooltip>
</template>

<script>
    export default {
        name: 'descriptionsTooltip',
        props: ['value','subValue','maxLength'],
        data () {
            return {
                tooltipDisabled: false,
            }
        },
        methods: {
            isShowTooltip () {
                console.log(this.maxLength);
                // 判断是否需要显示文字提示
                // const bool = this.$refs.content.offsetWidth < 200;
                let content = this.value;
                if(content != null || content !== ""){
                    // 获取传入value的长度（英文字符占1位，中文字符占2位）
                    let contentLength = this.calculateContentLength(content);

                    // 校验长度是否超过最大显示位数
                    this.tooltipDisabled = contentLength <= this.maxLength;
                }else{
                    this.tooltipDisabled = true;
                }
            },
            calculateContentLength(content){
                let contentLength = 0;
                if(content != null || content !== ""){
                    // 获取字符串长度
                    let cnReg = /([\u4e00-\u9fa5]|[\u3000-\u303F]|[\uFF00-\uFF60])/g;
                    let mat = content.match(cnReg);
                    if (mat) {
                        contentLength = mat.length * 2 + (content.length - mat.length);
                    } else{
                        contentLength = content.length;
                    }
                }
                return contentLength;
            }
        }
    }
</script>

<style scoped>

</style>